import { namespacer } from 'util/namespace';
import { TW_API_URL } from 'config';

const NAMESPACE = 'APP';

export const GET_TEAMS_REQUEST_START = namespacer(
  NAMESPACE,
  'GET_TEAMS_REQUEST_START'
);
export const GET_TEAMS_REQUEST_SUCCESS = namespacer(
  NAMESPACE,
  'GET_TEAMS_REQUEST_SUCCESS'
);
export const GET_TEAMS_REQUEST_ERROR = namespacer(
  NAMESPACE,
  'GET_TEAMS_REQUEST_ERROR'
);

export function getTeamsRequestStart() {
  return {
    type: GET_TEAMS_REQUEST_START,
  };
}

export function getTeamsRequestSuccess(teams) {
  return {
    type: GET_TEAMS_REQUEST_SUCCESS,
    teams,
  };
}

export function getTeamsRequestError(error) {
  return {
    type: GET_TEAMS_REQUEST_ERROR,
    error,
  };
}

export function getTeamsRequest(season) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getTeamsRequestStart());

      getTeamsQuery(season)
        .then((teams) => {
          dispatch(getTeamsRequestSuccess(teams));
          resolve(teams);
        })
        .catch((error) => {
          dispatch(getTeamsRequestError(error));
          reject(error);
        });
    });
  };
}

function getTeamsQuery(season) {
  return new Promise((resolve, reject) => {
    fetch(`${TW_API_URL}/twdt/${season}/teams`)
      .then((data) => data.json())
      .then((teams) => {
        resolve(teams);
      })
      .catch((error) => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/actions/app.js